module.exports = __webpack_public_path__ + "img/IMG_6961.0a3f2ffa.webp";